import * as React from 'react';
import { Reservable } from '../../../../commonv3/types/reservable';
import { ReservationSubPane } from '../../atoms/reservations/ReservationPane';
import { ReservableSummary } from './ReservableSummary';

type Props = {
    title: string;
    reservable: Reservable;
};
export const ReservationSummaryPane = ({ title, reservable }: Props) => (
    <ReservationSubPane>
        <ReservableSummary title={title} reservable={reservable} />
    </ReservationSubPane>
);
